var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{class:[
    'asc-page-error--container',
    _vm.errorType === 500 ? 'no-nav' : 'with-nav' ],attrs:{"fluid":""}},[_c('asc-page-error-template',{attrs:{"error-type":_vm.errorType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }